const f = 'f';
const t = 't';
const e = 'e';

const forrests = [
    [
        [t, t, t],
        [t, f, f],
        [t, t, t],
    ],
    [
        [e, e, e, t, e],
        [t, e, f, f, t],
        [t, t, t, t, t],
        [e, t, e, e, t],
    ],
    [[t], [f], [f], [t]],
    [
        [e, e, e, t, e],
        [t, e, t, t, t],
        [f, f, t, t, t],
        [e, t, e, e, t],
    ],
    [
        [t, t, t, t, t, t, t],
        [t, t, t, t, t, t, t],
        [t, t, t, t, t, t, t],
        [t, t, t, t, t, t, t],
        [t, t, t, t, t, t, t],
        [t, t, t, t, t, f, f],
    ],
    [
        [e, e, e, t, e],
        [t, e, f, f, t],
        [t, t, t, t, t],
        [e, t, e, e, t],
    ],
    [
        [e, e, e, e, e, t, e, e],
        [e, e, e, e, e, t, e, e],
        [e, e, e, e, e, t, t, e],
        [e, e, e, t, t, t, t, e],
        [e, t, t, t, t, t, t, t],
        [e, t, f, f, t, t, t, t],
        [t, t, t, t, t, t, t, t],
        [t, t, t, t, t, t, t, t],
        [t, t, t, t, t, t, t, t],
    ],
    [
        [e, e, e, t, e],
        [t, e, f, f, t],
        [t, t, t, t, t],
        [e, t, e, e, t],
    ],
    [
        [e, e, e, t, e],
        [t, e, f, f, t],
        [t, t, t, t, t],
        [e, t, e, e, t],
    ],
];

export default forrests;
